import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from 'src/app/auth/auth.service';
import { OptionService } from 'src/app/options/option.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  role: string = "";
  userLoginId!: string;
  ballance = 0;

  overview: any = null;
  spinnerOverlay = false;

  // validated categorical palette (fixed order, never cycled) - see dataviz palette validation
  typeColors = ['#673AB7', '#00897B', '#EF6C00', '#1E88E5'];
  trendColor = '#673AB7';
  categoryColor = '#00897B';
  growthColor = '#1E88E5';
  commissionsColor = '#EF6C00';
  balanceColor = '#673AB7';

  kpis = [
    { key: 'totalUsers', label: 'kpiTotalUsers', icon: 'group', tone: 'tone-purple' },
    { key: 'todayTradedAmount', label: 'kpiTodayTradedAmount', icon: 'payments', tone: 'tone-teal' },
    { key: 'todayOperationsCount', label: 'kpiTodayOperationsCount', icon: 'receipt_long', tone: 'tone-blue' },
    { key: 'todayCommissions', label: 'kpiTodayCommissions', icon: 'savings', tone: 'tone-orange' },
    { key: 'pendingDeviceApprovals', label: 'kpiPendingDevices', icon: 'phonelink_lock', tone: 'tone-red' }
  ];

  kpiValue(key: string): any {
    return this.overview?.[key] ?? 0;
  }

  // maps backend-coded values (operation types, "Uncategorized" fallback) to i18n keys;
  // labels not in this map (category names, dates, user full names) are real data, shown as-is
  private labelKeyMap: { [key: string]: string } = {
    CardPurchase: 'operationTypeCardPurchase',
    EFawateercom: 'operationTypeEFawateercom',
    BalanceTransfer: 'operationTypeBalanceTransfer',
    GovernmentService: 'operationTypeGovernmentService',
    Uncategorized: 'uncategorized'
  };

  // returns an i18n key for known backend codes; otherwise returns the label itself,
  // since ngx-translate's pipe falls back to printing an unmatched key unchanged
  translateLabel(label: string): string {
    return this.labelKeyMap[label] || label;
  }

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private optionService: OptionService
  ) {

  }

  ngOnInit(): void {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.role = this.localStorage.retrieve("userInfo").role;
    console.log(this.role)
    if (this.role == "Admin") {
      this.getOverview();
    }
    else {
      this.getUserLoginBalance()
    }
  }

  getUserLoginBalance() {
    this.authService.getById(this.userLoginId).subscribe(data => {
      this.ballance = data["balance"];
    })
  }

  getOverview() {
    this.spinnerOverlay = true;
    this.optionService.getDashboardOverview().subscribe(data => {
      this.overview = data;
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  // bar height as a percentage of the tallest bar in the series (min 4% so a zero value still shows a sliver baseline)
  barHeight(value: number, series: { amount?: number, count?: number }[], key: 'amount' | 'count'): number {
    const max = Math.max(...series.map(x => x[key] || 0), 1);
    return Math.max((value / max) * 100, value > 0 ? 6 : 2);
  }

  maxCount(series: { count: number }[]): number {
    return Math.max(...series.map(x => x.count), 1);
  }

}
